/** This component is used to display the tools panel content for the map, which
is consistent between the desktop and mobile views. It is used to select the
current layer and toggle the zoom to selected feature. */

<template>
  <div class="p-3">
    <!-- Layer Selection Section -->
    <h3 class="text-muted text-uppercase fw-bold mb-2 h6 fs-6">Layers</h3>
    <div
      class="btn-group-vertical w-100 mb-3"
      role="group"
      aria-label="Layer selection"
    >
      <button
        type="button"
        class="btn btn-outline-primary"
        :class="{ active: currentLayer === 'none' }"
        :aria-pressed="currentLayer === 'none'"
        :aria-label="
          currentLayer === 'none' ? 'None layer selected' : 'Select None layer'
        "
        @click="$emit('selectLayer', 'none')"
      >
        None
      </button>
      <button
        type="button"
        class="btn btn-outline-primary"
        :class="{ active: currentLayer === 'cultural' }"
        :aria-pressed="currentLayer === 'cultural'"
        :aria-label="
          currentLayer === 'cultural'
            ? 'Cultural regions layer selected'
            : 'Select Cultural regions layer'
        "
        @click="$emit('selectLayer', 'cultural')"
      >
        Cultural
      </button>
      <button
        type="button"
        class="btn btn-outline-primary"
        :class="{ active: currentLayer === 'migration_wave_1' }"
        :aria-pressed="currentLayer === 'migration_wave_1'"
        :aria-label="
          currentLayer === 'migration_wave_1'
            ? 'Migration Wave 1 layer selected'
            : 'Select Migration Wave 1 layer'
        "
        @click="$emit('selectLayer', 'migration_wave_1')"
      >
        Migration Wave 1
      </button>
      <button
        type="button"
        class="btn btn-outline-primary"
        :class="{ active: currentLayer === 'migration_wave_2' }"
        :aria-pressed="currentLayer === 'migration_wave_2'"
        :aria-label="
          currentLayer === 'migration_wave_2'
            ? 'Migration Wave 2 layer selected'
            : 'Select Migration Wave 2 layer'
        "
        @click="$emit('selectLayer', 'migration_wave_2')"
      >
        Migration Wave 2
      </button>
    </div>

    <!-- Divider -->
    <hr class="my-3" />

    <!-- Zoom Settings Section -->
    <h3 class="text-muted text-uppercase fw-bold mb-2 h6 fs-6">
      Zoom Settings
    </h3>
    <div
      class="form-check form-switch d-flex align-items-center justify-content-between"
    >
      <input
        class="form-check-input mt-0"
        type="checkbox"
        role="switch"
        :id="`zoom-to-selected${idSuffix}`"
        :checked="zoomToSelected"
        :aria-checked="zoomToSelected"
        aria-label="Zoom to selected item"
        @change="$emit('toggleZoom', $event.target.checked)"
      />
      <label
        class="form-check-label fs-6"
        style="cursor: pointer; user-select: none"
        :for="`zoom-to-selected${idSuffix}`"
      >
        Zoom to Selected
      </label>
    </div>
  </div>
</template>

<script>
export default {
  name: "ToolsPanelContent",
  props: {
    currentLayer: {
      type: String,
      required: true
    },
    zoomToSelected: {
      type: Boolean,
      required: true
    },
    idSuffix: {
      type: String,
      default: ""
    }
  },
  emits: ["selectLayer", "toggleZoom"]
};
</script>

<style scoped>
/* All styling handled by Bootstrap utility classes */
</style>
